export default "__VITE_ASSET__ec097b4f__"